import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'helpers/GlobalHelper';
import Header from '../Header';
import Network from '../Network';

import Style from './ForgotPassword.module.scss';

const ForgotPassword = ({
  autoFocus,
  forgotPasswordError,
  genericForgotPasswordError,
  headerProps,
  language,
  network,
  onFieldChange,
  onForgotPassword,
  signinEmail,
}) => {
  const {
    profileResetPw_message: resetPwMessage,
    profile_emailInputPlaceholder: emailPlaceholder,
    profileResetPw_invalidEmailText: invalidEmailText,
    profileResetPw_button: resetPwButtonText,
  } = language || {};
  let emailErrorText;
  let errorText;

  if (forgotPasswordError) {
    emailErrorText = invalidEmailText;
  }

  if (genericForgotPasswordError) errorText = genericForgotPasswordError;

  return (
    <main className={Style.forgotPassword}>
      <Header {...headerProps} />
      <div className={Style.forgotPasswordContainer}>
        <div className={Style.secondaryHeader}>
          <Network network={network} />
        </div>
        <div className={Style.forgotPasswordFormContainer}>
          <div className={Style.forgotPasswordText}>{resetPwMessage}</div>
          <div className={Style.error}>{errorText}</div>
          <input
            className={Style.inputField}
            autoFocus={autoFocus}
            type="email"
            name="signinEmail"
            placeholder={emailPlaceholder}
            value={signinEmail}
            onChange={onFieldChange}
            autoCapitalize="none"
          />
          <div className={Style.error}>{emailErrorText}</div>
          <button className={Style.btnPrimary} onClick={onForgotPassword}>
            {resetPwButtonText}
          </button>
        </div>
      </div>
    </main>
  );
};

ForgotPassword.defaultProps = {
  autoFocus: null,
  backgroundClass: null,
  forgotPasswordError: null,
  genericForgotPasswordError: null,
  language: {},
  network: [],
  onFieldChange: noop,
  onForgotPassword: noop,
  signinEmail: '',
};

ForgotPassword.propTypes = {
  autoFocus: PropTypes.bool,
  backgroundClass: PropTypes.string,
  forgotPasswordError: PropTypes.string,
  genericForgotPasswordError: PropTypes.string,
  headerProps: PropTypes.shape({}).isRequired,
  language: PropTypes.shape({}),
  network: PropTypes.arrayOf(PropTypes.shape({})),
  onFieldChange: PropTypes.func,
  onForgotPassword: PropTypes.func,
  signinEmail: PropTypes.string,
};

export default ForgotPassword;
